module.exports = __webpack_public_path__ + "static/media/file.ccac04b0.svg";